<template>
  <div class="p-3 bg-white">
    <div id="EditTimeConditionFormContainer" class="vs-con-loading__container">
      <shared-time-conditions-edit
        :activeKeyword="activeKeyword"
        :activeType="activeType"
        :hourOptions="hourOptions"
        :minuteOptions="minuteOptions"
        :weekDayOptions="weekDayOptions"
        :monthDayOptions="monthDayOptions"
        :monthOptions="monthOptions"
        @editTimeConditionSuccess="editTimeConditionSuccess"
      ></shared-time-conditions-edit>

      <div class="text-center">
        <vs-button id="editTimeConditionButton" class="m-2" color="primary" type="filled" @click.prevent="updateTimeConditions">{{ $t('save') }}</vs-button>
        <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelEditTimeConditions">{{ $t('cancel') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import TimeCondition from '@/models/TimeCondition'
import SharedTimeConditionsEdit from '@/views/Shared/TimeConditions/Edit'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.TimeConditions.Edit',
  components: {
    SharedTimeConditionsEdit
  },
  data () {
    return {
      id: '',
      keyword: '',
      type: '',
      amportal: false,
      activeKeyword: '',
      activeType: 'holiday',
      hourOptions: [],
      minuteOptions: [],
      weekDayOptions: [],
      monthOptions: [],
      monthDayOptions: []
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.keyword = this.$route.params.keyword
    this.type = this.$route.params.type

    this.loadTimecondition()
  },
  methods: {
    async loadTimecondition () {
      this.$vs.loading({container: '#EditTimeConditionFormContainer'})

      const response = await TimeCondition.findAll({ keyword: this.keyword, type: this.type })

      this.hourOptions = response.data.meta.options.hourOptions
      this.minuteOptions = response.data.meta.options.minuteOptions
      this.weekDayOptions = response.data.meta.options.weekDayOptions
      this.monthOptions = response.data.meta.options.monthOptions
      this.monthDayOptions = response.data.meta.options.monthDayOptions
      this.amportal = response.data.meta.amportal


      EventBus.$emit('initTimeConditionGetFormData', {id: this.id})

      this.$vs.loading.close('#EditTimeConditionFormContainer > .con-vs-loading')
    },
    updateTimeConditions () {
      EventBus.$emit('initUpdateTimeCondition')
    },
    editTimeConditionSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_time_conditions_table')
      window.close()
    },
    cancelEditTimeConditions () {
      this.$windowOpenerHelper.notifyOpener('reload_time_conditions_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
